'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$26(outer) {
  this.b7L = null;
  this.b7J = null;
  this.b7K = false;
  this.b7H = null;
  this.b7I = false;
  this.b7M = false;
  this.b7N = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.b7L = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_LoginPageView$$anon$26 as $c_Lpresto_LoginPageView$$anon$26 };
$p = $c_Lpresto_LoginPageView$$anon$26.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$26;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$26() {
}
export { $h_Lpresto_LoginPageView$$anon$26 as $h_Lpresto_LoginPageView$$anon$26 };
$h_Lpresto_LoginPageView$$anon$26.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.b7L;
});
$p.t = (function() {
  if ((!this.b7K)) {
    this.b7J = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b7K = true;
  }
  return this.b7J;
});
$p.ag = (function() {
  if ((!this.b7I)) {
    this.b7H = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().ph(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b7I = true;
  }
  return this.b7H;
});
$p.v = (function() {
  if ((!this.b7N)) {
    this.b7M = false;
    this.b7N = true;
  }
  return this.b7M;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_LoginPageView$$anon$26 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$26, "presto.LoginPageView$$anon$26", ({
  Mq: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$26 as $d_Lpresto_LoginPageView$$anon$26 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$26.js.map
